<template>
    <v-app>
        <v-row class="fill-height">
            <v-col sm="12" md="12" lg="3" class="pt-6 pl-2 col-12 section-1">
                <v-row justify="center">
                    <v-date-picker v-model="focus" elevation="1" :events="eventsPicker" event-color="green lighten-1">
                    </v-date-picker>
                </v-row>
                <v-row class="mt-2">
                    <v-card width="360" style=" box-shadow: none !important;" class="mx-auto ">
                        <v-container>
                            <v-col >
                                <v-col cols="12" style="padding:5px !important;">
                                    <v-card color="primary" dark>
                                        <v-card-title class="headline">Appointments</v-card-title>
                                    </v-card>
                                </v-col>
                                <v-col v-for="(item, i) in events" :key="i" cols="12" style="padding:5px !important;" >
                                    <v-card color="primary" dark  >
                                        <div class="d-flex flex-no-wrap justify-space-between text-center">
                                            <div>
                                                <v-card-title class="headline" v-text="item.remarks"></v-card-title>
                                                <v-card-subtitle v-html="toDate(item.start) + '  to  '  + toDate(item.end)"></v-card-subtitle>
                                                <v-span v-text="eventDuration(item.start, item.end)"></v-span>
                                            </div>
                                        </div>
                                    </v-card>
                                </v-col>
                            </v-col>
                        </v-container>
                    </v-card>
                </v-row>
            </v-col>
            <v-col sm="12" md="12" lg="9" class=" col-12 veautify-cal">
                <v-sheet height="64">
                    <v-toolbar flat color="white" offset-overflow="true">
                        <v-row class="btn-left-margin">
                            <v-col xs="12" sm="5" md="5" class="toolbar-col col-12">
                                <v-btn outlined class="me-4" color="grey darken-2" @click="setToday">
                                    Today
                                </v-btn>
                                <v-btn fab text small color="grey darken-2" @click="prev">
                                    <v-icon small>mdi-chevron-left</v-icon>
                                </v-btn>
                                <v-btn fab text small color="grey darken-2" @click="next">
                                    <v-icon small>mdi-chevron-right</v-icon>
                                </v-btn>
                                <span class="cal-title" v-if="$refs.calendar">
                                        {{ $refs.calendar.title }}
                                </span>
                            </v-col>
                            <v-col xs="12" sm="7" md="7" class="justify-content-end d-flex toolbar-col col-12">
                                <v-autocomplete
                                    v-model="zone"
                                    :items="timeZone"
                                    item-text="zone"
                                    item-value="zone"
                                    dense
                                    outlined
                                    item-color="primary"
                                    class ="zone toolbar-margin"
                                    hide-details: true
                                    v-on:change="changeZone()"
                                >
                                    <template slot='selection' slot-scope='{ item }'>
                                        {{ item.offset }} - {{ item.zone }}
                                    </template>
                                    <template slot='item' slot-scope='{ item }'>
                                        {{ item.offset }} - {{ item.zone }}
                                    </template>
                                </v-autocomplete>
                                <v-btn outlined class="toolbar-margin" color="grey darken-2" @click="defaultZone">
                                    Detect
                                </v-btn>
                                <v-menu bottom right>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                                            <span>{{ typeToLabel[type] }}</span>
                                            <v-icon right>mdi-menu-down</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item @click="type = 'day'">
                                            <v-list-item-title>Day</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item @click="type = 'week'">
                                            <v-list-item-title>Week</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item @click="type = 'month'">
                                            <v-list-item-title>Month</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item @click="type = '4day'">
                                            <v-list-item-title>4 days</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-toolbar>
                </v-sheet>
                <v-spacer></v-spacer>
                <v-sheet>
                    <v-calendar
                        ref="calendar"
                        v-model="focus"
                        color="primary"
                        :events="events"
                        :type="type"
                        :event-ripple="true"
                        @click:event="showEvent"
                        @click:more="viewDay"
                        @click:date="viewDay"
                        @mousedown:time="startTime"
                        @mousedown:event="startDrag"
                        @mousemove:time="mouseMove"
                        @mouseup:time="endDrag"
                        @mouseleave.native="cancelDrag"
                    >
                        <template #event="{ event, timed, eventSummary }">
                            <div class="v-event-draggable" v-html="eventSummary()"></div>
                            <div v-if="timed" class="v-event-drag-bottom" @mousedown.stop="extendBottom(event)">
                            </div>
                        </template>
                    </v-calendar>

                    <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement"
                        offset-x>
                        <v-card color="white" min-width="350px" flat>
                            <v-toolbar color="primary" dark>
                                <input solo class="text-white" v-model="selectedEvent.name" placeholder="Event Title" />
                                <v-spacer></v-spacer>
                                <v-btn icon @click="updateAppointment(selectedEvent)">
                                    <v-icon>mdi-content-save</v-icon>
                                </v-btn>
                                <v-btn icon @click="deleteAppointment(selectedEvent)">
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <input type="hidden" v-model="selectedEvent.start">
                                <input type="hidden" v-model="selectedEvent.end">
                                <span v-html="toDate(selectedEvent.start)"> </span>
                                to
                                <span v-html="toDate(selectedEvent.end)"> </span>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn text color="secondary" @click="selectedOpen = false">
                                    Cancel
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>
                </v-sheet>
            </v-col>
        </v-row>
    </v-app>

</template>

<script>
    import {mapGetters } from 'vuex'
    import moment from 'moment-timezone'
    import axios from "axios";
    export default {
        name: 'appointment-cal',
        props: ['userZone'],
        data: () => ({
            value: '',
            focus: '',
            type: '4day',
            typeToLabel: {
                month: 'Month',
                week: 'Week',
                day: 'Day',
                '4day': '4 Days',
            },
            appointments: {
                start: "",
                end: "",
                name: "",
                projectId: ""
            },
            moment:moment,
            zone: 'TimeZone',
            arrayEvents: null,
            dragEvent: null,
            dragStart: null,
            createEvent: null,
            createStart: null,
            extendOriginal: null,
            selectedEvent: {},
            selectedElement: null,
            selectedOpen: false,
            new: false,
            id: "",
        }),
        computed: mapGetters({
            events: 'appointments/appointments',
            timeZone: 'availabilities/zones'
        }),

        mounted() {
            if(this.userZone){
                this.zone = this.userZone
            }else{
                this.zone =moment.tz.guess();
            }
            this.fetchAppointments()
            this.$store.dispatch('availabilities/fetchTimeZones')
            this.eventsPicker()
        },

        methods: {
            fetchAppointments() {
               var url = window.location.pathname;
                var id = url.substring(url.lastIndexOf('/') + 1);
                this.$store.dispatch('appointments/fetchApointments', { id:id, zone:this.zone})
            },
            changeZone(){
                this.fetchAppointments()
            },
            defaultZone() {
                 if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(this.getTimezone);
                } else {
                    x.innerHTML = "Geolocation is not supported by this browser.";
                }
            },
            getTimezone(position){
                 const latitude = position.coords.latitude;
                const longitude=  position.coords.longitude;
                 axios.post('/api/timezones', {
                        latitude:latitude,
                        longitude:longitude
                    })
                    .then(res => {
                        const response = JSON.parse(res.data)
                        this.zone = response[0]
                        this.fetchAppointments()
                    }).catch(err => {
                        console.log(err)
                    })
            },
            viewDay({
                date
            }) {
                this.focus = date
                this.type = 'day'
            },
            setToday() {
                this.focus = ''
            },
            prev() {
                this.$refs.calendar.prev()
            },
            next() {
                this.$refs.calendar.next()
            },
            showEvent({nativeEvent,event}) {
                const open = () => {
                    this.selectedEvent = event
                    this.selectedElement = nativeEvent.target
                    setTimeout(() => this.selectedOpen = true, 10)
                }

                if (this.selectedOpen) {
                    this.selectedOpen = false
                    setTimeout(open, 10)
                } else {
                    open()
                }

                nativeEvent.stopPropagation()
            },
            startDrag({event,timed}) {
                if (event && timed) {
                    this.dragEvent = event
                    this.dragTime = null
                    this.extendOriginal = null
                }
            },
            startTime(tms) {
                const mouse = this.toTime(tms)

                if (this.dragEvent && this.dragTime === null) {
                    const start = this.dragEvent.start

                    this.dragTime = mouse - start
                } else {
                    this.createStart = this.roundTime(mouse)
                    this.createEvent = {
                        name: 'New Event',
                        start: this.createStart,
                        end: this.createStart,
                        timed: true,
                    }
                }
            },
            extendBottom(event) {
                this.createEvent = event
                this.createStart = event.start
                this.extendOriginal = event.end
            },
            mouseMove(tms) {
                const mouse = this.toTime(tms)

                if (this.dragEvent && this.dragTime !== null) {
                    const start = this.dragEvent.start
                    const end = this.dragEvent.end
                    const duration = end - start
                    const newStartTime = mouse - this.dragTime
                    const newStart = this.roundTime(newStartTime)
                    const newEnd = newStart + duration

                    this.dragEvent.start = newStart
                    this.dragEvent.end = newEnd
                } else if (this.createEvent && this.createStart !== null) {
                    const mouseRounded = this.roundTime(mouse, false)
                    const min = Math.min(mouseRounded, this.createStart)
                    const max = Math.max(mouseRounded, this.createStart)
                    this.createEvent.start = min
                    this.createEvent.end = max
                    this.appointments.end = this.createEvent.end
                }
            },
            endDrag() {
                if (this.dragEvent) {
                    this.updateAppointment(this.dragEvent)
                } else if (this.extendOriginal){
                    this.updateAppointment(this.createEvent)
                }
                this.dragTime = null
                this.dragEvent = null
                this.createEvent = null
                this.createStart = null
                this.extendOriginal = null
                this.appointments.end = null
                this.appointments.start = null
                this.appointments.name = null

            },
            cancelDrag() {
                if (this.createEvent) {
                    if (this.extendOriginal) {
                        this.createEvent.end = this.extendOriginal
                    } else {
                        const i = this.events.indexOf(this.createEvent)
                        if (i !== -1) {
                            this.events.splice(i, 1)
                        }
                    }
                }
                this.createEvent = null
                this.createStart = null
                this.dragTime = null
                this.dragEvent = null
            },
            roundTime(time, down = true) {
                const roundTo = 15 // minutes
                const roundDownTime = roundTo * 60 * 1000

                return down ?
                    time - time % roundDownTime :
                    time + (roundDownTime - (time % roundDownTime))
            },
            toTime(tms) {
                return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
            },
            eventsPicker() {
                this.arrayEvents = [this.events.start].map(() => {
                    const day = this.events
                    day.forEach((item) => {
                        const d = new Date(item.start)
                        var n = d.getDate()
                    })
                })
            },
            createAppointment(appointment) {
                this.$store.dispatch('appointments/createAppointment', appointment)
            },
            updateAppointment(selectedEvent) {
                this.$store.dispatch('appointments/updateAppointment',  {appointment:selectedEvent, zone:this.zone})
                this.selectedOpen = false
            },
            deleteAppointment(selectedEvent) {
                this.$store.dispatch('appointments/deleteAppointment', selectedEvent)
                this.selectedOpen = false
            },
            rnd(a, b) {
                return Math.floor((b - a + 1) * Math.random()) + a
            },
            rndElement(arr) {
                return arr[this.rnd(0, arr.length - 1)]
            },
            eventDuration(t1,t2){
                var t2 = moment(t2);
                var t1 = moment(t1);
                return  "Duration: "+t2.diff(t1, 'hours')+ "  hours"
            },
            toDate(unix){
                return moment(unix).format('DD/MM/YY hh:mm a');
            }
        },
    }

</script>
<style scoped lang="scss">
    .v-event-draggable {
        padding-left: 7px;
    }

    .v-event-timed {
        user-select: none;
        -webkit-user-select: none;
    }

    .v-event-drag-bottom {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 4px;
        height: 4px;
        cursor: ns-resize;

        &::after {
            display: none;
            position: absolute;
            left: 50%;
            height: 4px;
            border-top: 1px solid white;
            border-bottom: 1px solid white;
            width: 16px;
            margin-left: -8px;
            opacity: 0.8;
            content: '';
        }

        &:hover::after {
            display: block;
        }
    }

    .toolbar-margin{
        margin-right: 16px;
    }
    ::v-deep .v-select__selections{
        flex-wrap: nowrap;
    }

    .cal-title {
        font-size: 18px;
        font-weight: 400;
        line-height: 2rem;
    }

    .v-btn {
        height: 40px !important;
    }

    @media only screen and (max-width:1264px) {
        .section-1 {
            display: flex;
            align-items: center
        }
    }

    @media only screen and (max-width:768px) {

        .row.btn-left-margin button,
        .cal-title {
            margin-bottom: 25px !important;
        }

        .v-btn {
            font-size: x-small;
            height: 38px !important;
        }

        .spacer {
            height: 30px;
        }

        .toolbar-col {
            display: flex;
            justify-content: space-around !important;
            align-items: center;
        }

        ::v-deep .v-select__selections {
            font-size: 12px;
            line-height: 16px;
        }

        .section-1 {
            flex-direction: column;
        }

        .headline {
            font-size: 18px !important;
        }
    }

    @media only screen and (max-width:600px) {
        .v-btn {
            height: 39px;
            min-width: 62px;
            padding: 0 5px !important;
        }

        .toolbar-col {
            justify-content: space-between !important;
            margin-bottom: -30px !important;
        }
    }
    @media only screen and (max-width:420px) {
        .toolbar-margin{
        margin-right: 5px;
    }
    .cal-title{
        font-size: 15px;
    }
    }

    @media only screen and (max-width:350px) {
        .v-btn {
            padding: 0 4px !important;
        }

        .toolbar-col {
            padding: 10px 0;
        }
    }

</style>
